export const SLIDER_LOADING = 'SLIDER_LOADING';
export const SLIDER_FULFILLED = 'SLIDER_FULFILLED';
export const SLIDERS_FULFILLED = 'SLIDERS_FULFILLED';